import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { getFeatureFlags } from '../../service/FeatureFlagService';
import { useCompany } from '../CompanySelection/CompanyContext';
import './NotificationBanner.css'

const NotificationBanner = props => {
    const [isBannerOpen, setIsBannerOpen] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [messages, setMessages] = useState([]);
    const { companyNumber } = useCompany();

    const errorElement = <div className="efup-notification-banner-error" data-testid="efup-notification-banner-unavailable">
        <h3>Notification Banner is unavailable</h3>
    </div>;

    function dataHandler(data) {

        const features = data.features;
        const messages = features.filter((feature) => {
            return feature.message;
        }).map((feature) => {
            return feature.message;
        })

        setMessages(messages);
        setIsBannerOpen(messages && messages.length > 0);
        setHasError(false);
    }

    function errorHandler(error) {
        setHasError(true);
    }

    useEffect(() => {
        if (companyNumber) {    //company number may be null when initial company api call is executing
            getFeatureFlags(companyNumber, dataHandler, errorHandler);
        }
    }, [companyNumber])

    if (!isBannerOpen && !hasError) {
        return <></>;
    }

    return (
        <div className="cb-row">
            <div className="cb-form-group" data-testid="efup-notification-banner">
                <div className="cb-notification cb-notification-error">

                    <i
                        className="efup-notification-banner-close-icon cb-icon icon-close"
                        alt="Close Button"
                        onClick={() => setIsBannerOpen(false)}
                        data-testid="efup-notification-banner-close-button"
                    />
                    
                    {hasError ? errorElement :
                        messages.map((message, i) => {
                            return <div 
                                    key={`efup-notification-banner-message-${i}-wrapper`} 
                                    className="efup-notification-banner-message-wrapper">
                                    
                                    <i className="cb-icon icon-warning"></i>
                                    <span 
                                        className="cb-notification-text"
                                        data-testid={`efup-notification-banner-message-${i}`}
                                    >
                                        <ReactMarkdown>{message}</ReactMarkdown>
                                    </span>
                                </div>
                        })}
                    </div>
                </div>
        </div>
    );
}

export default NotificationBanner;